<template>
  <div class="row no-gutters" v-if="selectedData">
    <div class="col-md-5">
      <div class="fleet-image">
        <img
          :src="getValidFleetImage()"
          alt="Fleet Image"
          class="w-100 h-100 object-fit-cover"
        />
      </div>
    </div>
    <div class="col-md-7">
      <div class="pl-3">
        <div class="d-flex align-items-center mb-2">
          <img
            :src="require('../Components/Icons/icon-fleet.svg')"
            class="icon-badge mr-2"
          />
          <div>
            <h5 class="mb-0 text-primary font-semibold">
              {{ selectedData.vehicle_name }}
              <span class="ml-2 text-danger">●</span>
            </h5>
            <strong class="text-black mb-2">
              {{ selectedData.company_name }}
            </strong>
          </div>
        </div>
        <table class="table table-striped mb-0">
          <tbody>
            <tr>
              <td class="text-muted">Fleet Type</td>
              <td class="font-semibold text-capitalize">
                {{ selectedData.vehicle_type_name }}
              </td>
            </tr>
            <tr>
              <td class="text-muted">Call Sign</td>
              <td class="font-semibold">{{ selectedData.vehicle_code }}</td>
            </tr>
            <tr>
              <td class="text-muted">Flag</td>
              <td class="font-semibold">{{ selectedData.vehicle_flag }}</td>
            </tr>
            <tr>
              <td class="text-muted">Year & Building</td>
              <td class="font-semibold">
                {{ selectedData.year_build_country ?? '-' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PmsFleetDetailHeader',
  props: {
    fleetDetail: {
      type: Object,
      default: () => null,
    },
    selectedData: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    isValidUrl(url) {
      if (!url || typeof url !== 'string') return false
      try {
        new URL(url)
        return true
      } catch {
        return false
      }
    },
    getValidFleetImage() {
      const primaryUrl = this.selectedData?.vehicle_img?.url
      const secondaryUrl = this.selectedData?.vehicle_type_icon?.url

      // Jika URL pertama valid, gunakan
      if (this.isValidUrl(primaryUrl)) {
        return primaryUrl
      }

      // Jika URL pertama ada tapi tidak valid, cek URL kedua
      if (primaryUrl && !this.isValidUrl(primaryUrl)) {
        if (this.isValidUrl(secondaryUrl)) {
          return secondaryUrl
        }
      }

      // Jika keduanya tidak valid, gunakan fallback
      return this.isValidUrl(secondaryUrl) ? secondaryUrl : require('../Components/Icons/icon-fleet.svg')
    },
  },
}
</script>
<style scoped>
.fleet-image {
  width: 100%;
  height: 240px;
  background: #e9edf4 center/cover no-repeat;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.icon-badge {
  width: 60px;
  height: 60px;
  background: #f4efe6;
  border-radius: 6px;
  display: inline-block;
}
</style>
